module.exports = __webpack_public_path__ + "rosacea_8_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/rosacea_8_before.jpg
// module id = 992
// module chunks = 0